<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="flex align-items-center">
                <div>
                  <Avatar size="large" class="primary" icon="pi pi-shopping-cart" />
                </div>
                <div class="ml-2 mr-3">
                  <div class="text-2xl text-primary font-bold">CAPS Mall</div>
                  <div class="text-sm text-500">
                    Offer admissions to applicants
                  </div>
                </div>
                <div class="">
                  <router-link :to="`/applicants/capsmall_applications`">
                    <Button label="View All Applications" class="px-5 py-3 p-button-primary" />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section mb-3">
      <hr />
      <div class="container-fluid">
        <div class="grid justify-content-between">
          <div class="col">
            <span class="p-input-icon-left w-full">
              <i class="pi pi-search" />
              <InputText outlined dense placeholder="Search by school" class="w-full" v-model="searchInput" />
            </span>
          </div>
          <div class="col">
            <div class="mb-2">
              <Dropdown class="w-full" v-model="filters.applicants_country" :options="['Ghana', 'Other Nationals']"
                placeholder="Filter by Country">
              </Dropdown>
            </div>
          </div>
          <div class="col">
            <div class="">
              <div class="q-pa-sm">
                <Dropdown class="w-full" @input="
                    setFilter($menus.applicantsgenderItems, 'applicants_gender')
                  " v-model="filters.applicants_gender" optionLabel="label" optionValue="value"
                  :options="$menus.applicantsgenderItems" placeholder="Filter by Gender">
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="">
              <div class="q-pa-sm">
                <Dropdown class="w-full" @input="
                    setFilter(
                      $menus.applicantsshs_courseItems,
                      'applicants_shs_course'
                    )
                  " v-model="filters.applicants_shs_course" optionLabel="label" optionValue="value"
                  :options="$menus.applicantsshs_courseItems" placeholder="Filter by SHS Course">
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="">
              <div class="q-pa-sm">
                <InputText outlined dense placeholder="Search by Applicant Grade" class="w-full"
                  v-model="filters.applicants_shs_grade" type="number" max="24" min="6" />
                <!-- <Dropdown
                  class="w-full"
                  @input="
                    setFilter(
                      $menus.applicantsshs_courseItems,
                      'applicants_shs_course'
                    )
                  "
                  v-model="filters.applicants_shs_course"
                  optionLabel="label"
                  optionValue="value"
                  :options="$menus.applicantsshs_courseItems"
                  placeholder="Filter by SHS Course"
                >
                </Dropdown> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="flex align-items-center justify-content-around">
              <div v-if="searchText"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Search
                <Chip class="font-medium px-2 py-1" removable @remove="clearSearch()">{{ searchText }}</Chip>
              </div>
              <div v-if="filters.applicants_country"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Country
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_country = ''">
                  <span v-if="filtersLabel.applicants_country">{{
                    filtersLabel.applicants_country.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_country }}</span>
                </Chip>
              </div>
              <div v-if="filters.applicants_gender"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Gender
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_gender = ''">
                  <span v-if="filtersLabel.applicants_gender">{{
                    filtersLabel.applicants_gender.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_gender }}</span>
                </Chip>
              </div>
              <div v-if="filters.applicants_shs_course"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                SHS Course
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_shs_course = ''">
                  <span v-if="filtersLabel.applicants_shs_course">{{
                    filtersLabel.applicants_shs_course.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_shs_course }}</span>
                </Chip>
              </div>
              <div v-if="filters.applicants_shs_grade"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                SHS Grade
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_shs_grade = ''">
                  <span v-if="filtersLabel.applicants_shs_grade">{{
                    filtersLabel.applicants_shs_grade.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_shs_grade }}</span>
                </Chip>
              </div>
            </div>
            <div class="">
              <div>
                <template v-if="showBreadcrumbs && $route.query.tag">
                  <Breadcrumb :home="{ icon: 'pi pi-home', to: '/applicants' }" :model="pageBreadCrumb" />
                </template>
                <div class="relative-position">
                  <div class="grid">
                    <!-- Master Page Start -->
                    <div class="col-12">
                      <div class="page-records">
                        <div class="grid">
                          <template v-for="(data, i) of records" :key="i">
                            <div class="sm:col-6 md:col-3 col-12">
                              <div class="card card">
                                <div v-ripple @click="
                                    openPageDrawer(
                                      {
                                        page: 'applicants/view',
                                        url: `/applicants/view/${data.applicant_id}`,
                                      },
                                      {
                                        width: '40vw',
                                      }
                                    )
                                  " class="font-bold text-lg text-primary cursor-pointer">
                                  {{ data.firstname }} {{ data.lastname }}
                                </div>
                                <div class="text-500">
                                  {{ data.shs_course }}
                                </div>
                                <hr />
                                <div class="flex justify-content-between">
                                  <span class="font-bold text-500">{{
                                    data.shs_grade
                                    }}</span>
                                </div>
                                <div class="flex justify-content-between">
                                  <Button icon="pi pi-check" class="p-button-raised" :label="
                                      data.offer_count != '0'
                                        ? 'Offer Another Admission (' +
                                          data.offer_count +
                                          ')'
                                        : 'Offer Admission'
                                    " :class="
                                      data.offer_count != '0'
                                        ? 'p-button-success'
                                        : ''
                                    " @click="
                                      openPageDialog(
                                        {
                                          page: 'applicants/capsmall_offeradmission',
                                          url: `/applicants/offeradmission/${data.applicant_id}`,
                                        },
                                        { persistent: true, closeBtn: true }
                                      )
                                    " />
                                  <Button icon="pi pi-user" class="p-button-text p-button-outline" label="View Details"
                                    @click="
                                      openPageDrawer(
                                        {
                                          page: 'applicants/view',
                                          url: `/applicants/view/${data.applicant_id}`,
                                        },
                                        {
                                          width: '40vw',
                                        }
                                      )
                                    " />
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                      <!-- page loading indicator -->
                      <template v-if="loading">
                        <div v-show="loading" class="flex align-items-center justify-content-center text-gray-500">
                          <div>
                            <ProgressSpinner style="width: 30px; height: 30px" />
                          </div>
                        </div>
                      </template>
                      <!-- end of page loading indicator-->
                      <!-- Empty record -->
                      <template v-if="!loading && !records.length">
                        <div class="p-3 my-3 text-500 text-lg font-medium text-center">
                          No record found
                        </div>
                      </template>
                      <!-- end of empty record-->
                      <!-- pagination component-->
                      <template v-if="showFooter">
                        <div class="">
                          <div v-show="!loading">
                            <div class="flex justify-content-between">
                              <div class="flex justify-content-center flex-grow-0">
                                <div class="m-2" v-if="exportButton && records.length">
                                  <Button @click="
                                      (event) => $refs.exportMenu.toggle(event)
                                    " label="Export" title="Export" class="px-5 py-3 p-button-secondary"
                                    icon="pi pi-print" />
                                  <Menu ref="exportMenu" popup :model="pageExportFormats" />
                                </div>
                              </div>
                              <div v-if="paginate && totalPages > 1" class="flex-grow-1">
                                <Paginator class="" @page="(event)=>{pagination.page = event.page + 1}"
                                  :rows="pagination.rowsPerPage" :totalRecords="totalRecords">
                                  <template #start>
                                    <span class="text-sm text-gray-500 px-2">
                                      Records <b>{{ recordsPosition }} of {{ totalRecords }}</b>
                                    </span>
                                    <span class="text-sm text-gray-500 px-2">
                                      Page <b>{{ pagination.page }} of {{ totalPages }}</b>
                                    </span>
                                  </template>
                                  <template #end>
                                    <Dropdown v-model="pagination.rowsPerPage" :options="[5,10,15,20,30,40,50,100,200]">
                                    </Dropdown>
                                  </template>
                                </Paginator>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!-- end of pagination component-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { defineAsyncComponent, ref } from "vue";
  import { PageMixin } from "../../mixins/page.js";
  import { ListPageMixin } from "../../mixins/listpage.js";
  import { mapActions, mapGetters, mapState } from "vuex";
  export default {
    name: "capsmallApplicantsPage",
    components: {},
    mixins: [PageMixin, ListPageMixin],
    props: {
      primaryKey: {
        type: String,
        default: "applicant_id",
      },
      pageName: {
        type: String,
        default: "applicants",
      },
      routeName: {
        type: String,
        default: "applicantscapsmall",
      },
      apiPath: {
        type: String,
        default: "applicants/capsmall",
      },
      mergeRecords: {
        type: Boolean,
        default: false,
      },
      multiCheckbox: {
        type: Boolean,
        default: false,
      },
      msgBeforeDelete: {
        type: String,
        default: "Are you sure you want to delete this record?",
      },
    },
    data() {
      return {
        filters: {
          applicants_country: "",
          applicants_gender: "",
          applicants_shs_course: "",
          applicants_shs_grade: "",
        },
        filtersLabel: {},
        applicants_shs_grade: [],
        pageExportFormats: [
          {
            label: "Excel",
            icon: "pi pi-file-excel text-green-500",
            command: () => {
              this.exportPageRecords("excel", "xlsx");
            },
          },
          {
            label: "Csv",
            icon: "pi pi-table text-green-200",
            command: () => {
              this.exportPageRecords("csv", "csv");
            },
          },
        ],
      };
    },
    computed: {
      pageTitle: {
        get: function () {
          //set browser page title
          return "Applicants";
        },
      },
      records: {
        get: function () {
          return this.$store.getters["applicants/records"];
        },
        set: function (value) {
          this.$store.commit("applicants/setRecords", value);
        },
      },
      currentRecord: {
        get: function () {
          return this.$store.getters["applicants/currentRecord"];
        },
        set: function (value) {
          this.$store.commit("applicants/setCurrentRecord", value);
        },
      },
    },
    watch: {
      apiUrl: function () {
        this.load();
      },
    },
    methods: {
      ...mapActions("applicants", ["fetchRecords", "deleteRecord"]),
      getActionMenuModel(data) {
        return [];
      },
      load: function () {
        if (!this.loading) {
          this.loading = true;
          this.currentRecord = null;
          let url = this.apiUrl;
          let payload = {
            url,
            merge: this.mergeRecords,
          };
          this.fetchRecords(payload).then(
            (response) => {
              this.loading = false;
              this.ready = true;
              this.totalRecords = response.total_records;
              this.recordCount = response.record_count;
              this.pagination.rowsNumber = this.totalRecords;
              window.scrollTo(0, 0);
            },
            (response) => {
              this.loading = false;
              this.showPageRequestError(response);
            }
          );
        }
      },
    },
    async mounted() {
      this.$EventBus.on("caps-mall-offer", (id) => {
        let record = this.records.find((e) => e.applicant_id == id);
        if (record) {
          record.offer_count = parseInt(record.offer_count) + 1;
        }
      });
    },
    async created() { },
  };
</script>
<style scoped></style>